<div cdkDropListGroup class="container">
    <div class="displayed-sections-container">
        <as-split direction="horizontal" restrictMove="true" [useTransition]="true" [gutterSize]="sectionsGroupConfiguration.gutterSize" (dragEnd)="onSectionsGroupResized($event)">
            <ng-template ngFor let-sectionsGroup [ngForOf]="folderLayout.sectionsGroups" let-sectionsGroupIndex="index">
                @if (sectionsGroup.visible) {
                    <as-split-area
                        [size]="sectionsGroup.size"
                        [id]="'section-group-' + sectionsGroupIndex"
                        cdkDropList
                        [cdkDropListData]="sectionsGroup.sections"
                        (cdkDropListDropped)="onSectionDrop($event)"
                        style="min-width: 300px">
                        <as-split
                            [direction]="sectionsGroupConfiguration.dir"
                            [restrictMove]="sectionsGroupConfiguration.restrictMove"
                            [gutterSize]="sectionsGroupConfiguration.gutterSize"
                            [gutterStep]="sectionsGroupConfiguration.gutterStep"
                            [useTransition]="sectionsGroupConfiguration.useTransition"
                            gutterClickDeltaPx="0"
                            (dragEnd)="onSectionResized(sectionsGroupIndex, $event)">
                            <ng-template ngFor let-section [ngForOf]="sectionsGroup.sections" [ngForTrackBy]="trackBySectionFct" let-index="index">
                                <as-split-area [visible]="section.resizingStatus !== ResizingStatus.Hidden" [size]="section.size">
                                    <div
                                        class="section"
                                        cdkDrag
                                        [cdkDragData]="section"
                                        (cdkDragMoved)="onDragMove($event)"
                                        (cdkDragStarted)="onDragStart($event)"
                                        (cdkDragEnded)="onDragEnd($event)"
                                        [id]="'section-' + index">
                                        <div class="section-header">
                                            <div class="left-header">
                                                <fa-icon [icon]="dragAndDropIcon" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                            </div>
                                            <div class="center-header">
                                                @if (section.name === 'Documents') {
                                                    <a [ngClass]="{ 'sub-section-unselected': subSectionSelected !== 'Documents' }" (click)="onSubSectionSelected('Documents')">
                                                        <span class="label">Documents</span>
                                                    </a>
                                                    <span class="separator">/</span>
                                                    <a [ngClass]="{ 'sub-section-unselected': subSectionSelected !== 'DraftEmails' }" (click)="onSubSectionSelected('DraftEmails')">
                                                        <span>Brouillons de mail</span>
                                                    </a>
                                                } @else {
                                                    <span class="label">{{ section.name }}</span>
                                                }
                                            </div>
                                            <div class="right-header">
                                                @if (section.name === 'Documents') {
                                                    <fa-icon
                                                        [icon]="searchDocumentIcon"
                                                        class="fa-lg icon"
                                                        (click)="onSearch()"
                                                        matTooltip="Rechercher un document"
                                                        matTooltipPosition="below"></fa-icon>
                                                }
                                                @if (section.resizingStatus === ResizingStatus.Maximized || section.resizingStatus === ResizingStatus.VerticalMaximized) {
                                                    <fa-icon
                                                        [icon]="restoreSizeIcon"
                                                        class="fa-lg icon"
                                                        (click)="onRestoreSectionSize(section.name)"
                                                        matTooltip="Restaurer la taille normal"
                                                        matTooltipPosition="below"></fa-icon>
                                                }
                                                @if (section.resizingStatus !== ResizingStatus.VerticalMaximized && section.resizingStatus !== ResizingStatus.Maximized) {
                                                    <fa-icon
                                                        [icon]="verticalGrowIcon"
                                                        class="fa-lg icon"
                                                        (click)="onMaximizeSectionHeight(section.name)"
                                                        matTooltip="Agrandir verticalement"
                                                        matTooltipPosition="below"></fa-icon>
                                                }
                                                @if (section.resizingStatus !== ResizingStatus.Maximized) {
                                                    <fa-icon
                                                        [icon]="fullScreenIcon"
                                                        class="fa-lg icon"
                                                        (click)="onDisplaySectionInFullScreen(section.name)"
                                                        matTooltip="Agrandir en plein écran"
                                                        matTooltipPosition="below"></fa-icon>
                                                }
                                                <fa-icon
                                                    [icon]="removeSectionIcon"
                                                    class="fa-lg icon remove-icon"
                                                    (click)="onRemoveSection(section.name)"
                                                    matTooltip="Cacher la section"
                                                    matTooltipPosition="below"></fa-icon>
                                            </div>
                                        </div>
                                        <div class="section-content">
                                            @switch (section.name) {
                                                <!-- Affichage des documents -->
                                                @case ('Documents') {
                                                    <app-documents-section
                                                        [folder]="folder"
                                                        [selectedDocument]="selectedDocument"
                                                        [readonly]="readonly"
                                                        [idDocumentsTableDisplayed]="subSectionSelected === 'Documents'"
                                                        [documentSearchText]="documentSearchText()"
                                                        [draftEmailSearchText]="draftEmailSearchText()"
                                                        (dataMarkAsRead)="onDocumentMarkedAsRead($event)"
                                                        (contactAdded)="onContactAdded($event)"
                                                        (documentDeleted)="onDocumentDeleted($event)"
                                                        (mailReplied)="onMailReplied($event)"
                                                        (searchReseted)="onSearchReseted($event)"
                                                        (mailResended)="onMailResended($event)"></app-documents-section>
                                                }
                                                <!-- Affichage de la liste des attribut-->
                                                @case ('Attributs') {
                                                    <app-attributes-section
                                                        [attributesDefinitions]="attributesDefinitions"
                                                        [folder]="folder"
                                                        [view]="view"
                                                        [readonly]="readonly"></app-attributes-section>
                                                }
                                                <!-- Affichage des etapes des du workflows (Affiché si le dossier est dans un workflow )-->
                                                @case ('Workflow') {
                                                    <app-workflow-section
                                                        [workflowStepDefinitions]="workflowStepDefinitions$ | async"
                                                        [folder]="folder"
                                                        [workflowStepsSnapshot]="folder.workflowStepsSnapshot"
                                                        [readonly]="readonly"
                                                        [isDateVisible]="isWorkflowStepDateVisible"></app-workflow-section>
                                                }
                                                <!-- Affichage de l'historique-->
                                                @case ('Historique') {
                                                    <app-history-section [folder]="folder"></app-history-section>
                                                }
                                                <!-- Affichage des rappels-->
                                                @case ('Rappels') {
                                                    <app-reminders-section
                                                        [folder]="folder"
                                                        (reminderEdited)="onReminderEdited($event)"
                                                        (reminderDeleted)="onReminderDeleted($event)"></app-reminders-section>
                                                }
                                                <!-- Affiché si un document est selectionné -->
                                                @case ('Visualisateur') {
                                                    <app-viewer-section
                                                        [folderId]="folder.id"
                                                        [viewType]="view.viewType"
                                                        [viewId]="view.id"
                                                        [readonly]="readonly"
                                                        (commentEdited)="onCommentEdited($event)"
                                                        (commentDeleted)="onCommentDeleted($event)"></app-viewer-section>
                                                }
                                            }
                                        </div>
                                    </div>
                                </as-split-area>
                            </ng-template>
                        </as-split>
                    </as-split-area>
                }
            </ng-template>
        </as-split>
    </div>
    <div
        id="available"
        class="non-displayed-sections-container"
        cdkDropList
        [cdkDropListData]="folderLayout.nonDisplayedSections"
        [ngClass]="{ empty: folderLayout.nonDisplayedSections.length === 0 }">
        @for (section of folderLayout.nonDisplayedSections; track section.name) {
            <div
                class="non-displayed-section"
                cdkDrag
                [cdkDragData]="section"
                (cdkDragMoved)="onDragMove($event)"
                (cdkDragStarted)="onDragStart($event)"
                (cdkDragEnded)="onDragEnd($event)">
                <fa-icon [icon]="dragAndDropIcon" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                <span class="label">{{ section.name }}</span>
            </div>
        }
    </div>
</div>
